module.exports = __webpack_public_path__ + "static/media/languageIcon.cd8d3f5d.png";